import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { PrintOut } from '../reports/PrintOut';
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import { helper } from "../../componets/utils/helper";
import { Dialog } from "primereact/dialog";
import VotersService from "../../services/VotersService";
import { Dropdown } from "primereact/dropdown";
import { Image } from "primereact/image";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import { InputText } from "primereact/inputtext";
import { PrimeIcons } from "primereact/api";
import { OverlayPanel } from 'primereact/overlaypanel';
import MultiFilterSearch from "../../componets/MultiFilterSearch";
import { maskMiddle } from "../../config/Config";

export default function ({ header = null, hideButtons = false }) {
    var { selectedParty, isOnlyView, isIecEdit, partyExecutiveTermID } = useContext(PoliticalPartyDBContext);
    var political = new PoliticalPartyService();
    var [showPdf, setShowPdf] = useState(false);
    var [pdf, setPdf] = useState(null);
    var [executiveRoles, setExecutiveRoles] = useState([]);
    var [registerdMembers, setRegisterdMembers] = useState([]);
    var [excecutiveMembers, setExcecutiveMembers] = useState([]);
    const inputFileRef = useRef(null);
    const inputConsentFileRef = useRef(null);
    var [loading, setLoading] = useState(false);
    var [refresh, setRefresh] = useState(false);
    var raw_form = {
        show: false,
        show_dialog: false,
        voterRecord: null,
        idNumber: "",
        partyExecutiveRoleID: null,
        signature: "",
        fileType: "",
        "emailAddress": "",
        fileExtension: "",
        consentForm: "",
        consentFileType: "",
        consentFileExtension: "",
        other: ""
    }
    var [showAddDialog, setShowAddDialog] = useState(raw_form);

    var [showUpdate, setShowUpdate] = useState({
        show: false,
        show_dialog: false,
        voterRecord: null,
        idNumber: "",
        partyExecutiveRoleID: null,
        signature: "",
        fileType: "",
        "emailAddress": "",
        fileExtension: "",
        consentForm: "",
        consentFormName: "",
        consentFileType: "",
        consentFileExtension: "",
        other: ""

    });
    var { toast } = useContext(AppDB);

    var political = new PoliticalPartyService();
    var voterService = new VotersService();
    const op = useRef(null);
    var { contestationPeriodID } = useContext(PoliticalPartyDBContext);

    useEffect(() => {
        setLoading(true);


        //get  excecutive members
        political.getExcecutiveMembers(selectedParty.politicalPartyID, partyExecutiveTermID).then((excMembers) => {
            setExcecutiveMembers(excMembers);

            // setRegisterdMembers(removeMatchingItems(excMembers, res.members));

            //get Available Executive Roles
            political.getAvailableExecutiveRoles(selectedParty.politicalPartyID, partyExecutiveTermID).then((res) => {
                setExecutiveRoles((removeMatchingItems(excMembers, res)));
                setLoading(false);
            });
        });
    }, [selectedParty, refresh,]);


    // function removeMatchingItems(array1, array2) {
    //     return array2.filter((item2) => !array1.some((item1) => item1?.partyExecutiveRoleID === item2?.partyExecutiveRoleID));
    // }

    function removeMatchingItems(array1, array2) {
        var res = array2.filter((item2) => {
            // Always keep item2 if its role ID is 9
            if (item2.partyExecutiveRoleID === 9) return true;

            // Remove it if its ID exists in array1
            return !array1.some(item1 => item1?.partyExecutiveRoleID === item2?.partyExecutiveRoleID);
        });
        return res;
    }



    function HandlerAddPartyExecutiveMember() {

        // if (showAddDialog?.partyExecutiveRoleID === 3 && showAddDialog.emailAddress.trim().length === 0) {
        //     return toast.show({
        //         severity: "error",
        //         detail: "email is required",
        //         life: 2500
        //     });
        // }
        if (showAddDialog.partyExecutiveRoleID === 9) {
            if (["", null, undefined].includes((showAddDialog.other.trim()))) {
                return toast.show({
                    severity: "error",
                    detail: "Other role is required",
                    life: 2500
                });
            }
        }

        if (showAddDialog.consentForm.trim().length == 0) {
            return toast.show({
                severity: "error",
                detail: "Consent form is required",
                life: 2500
            });
        }


        setLoading(true);
        var clone = { ...showAddDialog }
        var image = clone.signature.split(",");
        if (image?.length > 0) {
            clone.signature = image.at(1)
        }
        political
            .AddExcecutiveMembers({
                voterID: showAddDialog.voterRecord.voterID,
                politicalPartyID: selectedParty.politicalPartyID,
                partyExecutiveRoleID: showAddDialog.partyExecutiveRoleID,
                signature: clone.signature,
                signatureContentType: showAddDialog.fileType,
                signatureExtension: showAddDialog.fileExtension,
                consentForm: showAddDialog.consentForm,
                consentFormName: showAddDialog.consentFormName,
                consentFormContentType: showAddDialog.consentFileType,
                consentFormExtension: showAddDialog.consentFileExtension,
                emailAddress: showAddDialog.emailAddress,
                partyExecutiveTermID: partyExecutiveTermID,
                other: showAddDialog.other
            })
            .then((res) => {
                setLoading(false);
                if (res.success) {
                    setShowAddDialog({
                        ...showAddDialog,
                        show: false,
                        voterRecord: null,
                        signature: "",
                        partyExecutiveRoleID: null,
                        idNumber: "",
                        fileExtension: "",
                        fileType: ""
                    });
                    setRefresh(!refresh);
                    toast.show({
                        severity: "success",
                        detail: "Elector Added",
                        life: 2500
                    });
                } else {
                    toast.show({
                        severity: "error",
                        detail: res.message,
                        life: 2500
                    });
                }
            });
    }

    const handleFileUpload = async (event) => {
        setLoading(true);
        const file = event.target.files[0];
        var base64File = await helper.convertFileToBase64(file);
        const extension = file.name.split(".").pop();
        setShowAddDialog({ ...showAddDialog, signature: base64File, fileExtension: extension, fileType: file.type });
        setLoading(false);
    };

    const handleConsentFormUpload = async (event) => {
        setLoading(true);
        const file = event.target.files[0];
        var base64File = await helper.convertFileToBase64(file);
        const extension = file.name.split(".").pop();
        const fileName = file.name;
        setShowAddDialog({ ...showAddDialog, consentForm: base64File.split(",").at(1), consentFileExtension: extension, consentFileType: file.type, consentFormName: fileName });
        setLoading(false);
    };

    const confirmDeleteExecutiveMember = (e, row) => {
        confirmDialog({
            target: e.currentTarget,
            message: "Are you sure you want to proceed?",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                setLoading(true);
                political.deleteExcecutiveMemberRole(row).then((res) => {
                    setLoading(false);
                    if (res.success) {
                        setRefresh(!refresh);
                        toast.show({
                            severity: "success",
                            detail: "Role Removed",
                            life: 2500
                        });
                    } else {
                        toast.show({
                            severity: "error",
                            detail: res.message,
                            life: 2500
                        });
                    }
                });
            },
            reject: () => { }
        });
    };

    function updateRole() {

        function isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        if (!isValidEmail(showUpdate.emailAddress)) {
            return toast.show({
                severity: "error",
                detail: "Invalid Email",
                life: 2500
            });
        }
        setLoading(true);
        political.updateExcecutiveMemberRole(showUpdate).then((res) => {
            setLoading(false);
            if (res.success) {
                setRefresh(!refresh);
                toast.show({
                    severity: "success",
                    detail: "Updated member details",
                    life: 2500
                });
                setShowUpdate({ ...showUpdate, show: false })
            } else {
                toast.show({
                    severity: "error",
                    detail: res.message,
                    life: 2500
                });
            }
        });
    }

    function searchVoterByIDNumber() {


        const isAlreadyAdded = excecutiveMembers.some(member =>
            member.registrationNumber === showAddDialog.idNumber ||
            member.idNumber === showAddDialog.idNumber
        );


        if (isAlreadyAdded) {
            return toast.show({
                severity: "error",
                detail: "Executive member already added.",
                life: 2500
            });
        }
        setLoading(true);
        voterService.searchVoter(showAddDialog.idNumber).then((res) => {
            var status = `${res}`;

            if (res?.eligibleStatus === "N") {
                setLoading(false);
                toast.show({
                    severity: "error",
                    detail: "Elector not eligible",
                    life: 2500
                });
                return
            }
            if (status.trim().length === 0) {
                setLoading(false);
                toast.show({
                    severity: "error",
                    detail: "Elector not Found",
                    life: 2500
                });
            } else {
                setShowAddDialog({
                    ...showAddDialog,
                    village: res?.village,
                    voterRecord: {
                        firstname: res.firstname,
                        surname: res.surname,
                        dateOfBirth: res.dateOfBirth,
                        gender: res.gender,
                        voterID: res.voterID
                    }
                });
            }
            setLoading(false);
        });
    }

    return (
        <>
            <ConfirmDialog />

            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
                {header !== null && <h5>{header}</h5>}
                {!hideButtons && <>
                    <div className="flex">
                        {!isOnlyView && (
                            <div>
                                <Button
                                    label="Add Member"
                                    loading={loading}
                                    onClick={() => {
                                        setShowAddDialog({ ...showAddDialog, ...raw_form, show: true, });
                                    }}
                                    className="p-button-success mr-3"
                                />
                            </div>
                        )}
                    </div>
                </>}

            </div>

            <Dialog
                header={
                    <>
                        <h5 className="my-0">Update -{showUpdate.firstname} </h5>
                    </>
                }
                style={{ width: "100%", maxWidth: "500px" }}
                onHide={() => {
                    setShowUpdate({ ...showUpdate, show: false, voterRecord: null, idNumber: "", signature: "" });
                }}
                visible={showUpdate.show}
                footer={
                    <>
                        <Button loading={loading} onClick={updateRole} label="Submit" />

                        <Button
                            className="p-button-danger"
                            onClick={() =>
                                setShowUpdate({
                                    ...showUpdate,
                                    show: false,
                                    voterRecordID: null,
                                    partyExecutiveRoleID: null,
                                    idNumber: "",
                                    fileExtension: "",
                                    fileType: "",
                                    signature: ""
                                })
                            }
                            label="Close"
                        />
                    </>
                }
            >

                <div className="grid">
                    <div className="col-12  md:col-6">
                        <b>Firstname</b>
                        <InputText className="w-full" disabled value={showUpdate.firstname} />
                    </div>

                    <div className="col-12  md:col-6 ">
                        <b>Surname</b>
                        <InputText className="w-full" disabled value={showUpdate.surname} />
                    </div>
                    <div className="col-12  md:col-12 ">
                        <b>Email<span style={{ color: "red" }}>*</span></b>
                        <InputText
                            value={showUpdate.emailAddress}
                            onChange={(e) => {
                                setShowUpdate({ ...showUpdate, emailAddress: e.target.value });
                            }}
                            className="w-full" />
                    </div>

                </div>

            </Dialog>


            <Dialog
                header={
                    <>
                        <h5 className="my-0">Add Executive Committee Member </h5>
                    </>
                }
                style={{ width: "100%", maxWidth: "700px" }}
                onHide={() => {
                    setShowAddDialog({ ...showAddDialog, show: false, voterRecord: null, idNumber: "", ...raw_form });
                }}
                visible={showAddDialog.show}
                footer={
                    <>
                        {!isOnlyView && (
                            <>
                                {showAddDialog.voterRecord !== null &&
                                    showAddDialog.partyExecutiveRoleID != null &&
                                    showAddDialog.signature.length != 0 && (
                                        <>
                                            <Button loading={loading} onClick={HandlerAddPartyExecutiveMember} label="Submit" />
                                        </>
                                    )}
                            </>
                        )}

                        <Button
                            className="p-button-danger"
                            onClick={() =>
                                setShowAddDialog({
                                    ...showAddDialog,
                                    show: false,
                                    voterRecordID: null,
                                    partyExecutiveRoleID: null,
                                    idNumber: "",
                                    fileExtension: "",
                                    fileType: ""
                                })
                            }
                            label="Close"
                        />
                    </>
                }
            >
                <div className="grid">
                    {/* <div className="col-12 f-bold">
                        <b>Search By ID/Registration Number</b>
                        <span style={{ color: "red" }}>*</span>
                    </div> */}
                    <div className="col-12">
                        <MultiFilterSearch
                            label={<>Search By <span style={{ color: "red" }}>*</span></>}
                            onClear={() => {
                                setShowAddDialog({
                                    ...showAddDialog,
                                    voterRecord: null,
                                    signature: "",
                                    partyExecutiveRoleID: null,
                                    idNumber: "",
                                    fileExtension: "",
                                    fileType: ""
                                });
                            }}
                            onChange={res => {

                                setShowAddDialog({
                                    ...showAddDialog,
                                    village: res?.village,
                                    voterRecord: {
                                        firstname: res.firstname,
                                        surname: res.surname,
                                        dateOfBirth: res.dateOfBirth,
                                        gender: res.gender,
                                        voterID: res.voterID
                                    }
                                });
                            }} />
                    </div>
                </div>
                <div className=" flex my-2">
                    {/* <InputText
                        maxLength={14}
                        style={{ width: "100%" }}
                        placeholder="Search By ID/Registration Number"
                        value={showAddDialog.idNumber}
                        onChange={(e) => {
                            setShowAddDialog({ ...showAddDialog, idNumber: e.target.value.trim().toLowerCase() });
                        }}
                    /> */}

                    {/* <Button
                        className="ml-2"
                        loading={loading}
                        disabled={showAddDialog.idNumber.length < 6}
                        label="Search"
                        onClick={() => {
                            searchVoterByIDNumber();
                        }}
                    /> */}
                </div>

                {showAddDialog.voterRecord !== null && (
                    <>
                        <hr></hr>
                        <div className="grid">
                            <div className="col-12  md:col-6">
                                <b>Firstname</b>
                                <InputText className="w-full" disabled value={showAddDialog.voterRecord.firstname} />
                            </div>

                            <div className="col-12  md:col-6 ">
                                <b>Surname</b>
                                <InputText className="w-full" disabled value={showAddDialog.voterRecord.surname} />
                            </div>

                            <div className="col-12">
                                <b>Role</b>
                                <span style={{ color: "red" }}>*</span>
                                <Dropdown
                                    className="w-full"
                                    optionLabel="name"
                                    value={showAddDialog.partyExecutiveRoleID}
                                    optionValue="partyExecutiveRoleID"
                                    options={executiveRoles.filter(function (item) {
                                        if (item.partyExecutiveRoleID === 9) return true
                                        return item.voterID === null
                                    })
                                    }
                                    onChange={(e) => {
                                        setShowAddDialog({ ...showAddDialog, partyExecutiveRoleID: e.value });
                                    }}
                                />
                            </div>

                            <div className="col-12  md:col-12 ">
                                <b>Email<span style={{ color: "red" }}>{showAddDialog?.partyExecutiveRoleID === 3 && ("")}</span></b>
                                <InputText
                                    value={showAddDialog.emailAddress}
                                    onChange={(e) => {
                                        setShowAddDialog({ ...showAddDialog, emailAddress: e.target.value });
                                    }}
                                    className="w-full" />
                            </div>

                            {showAddDialog.partyExecutiveRoleID == 9 && <div className="col-12  md:col-12 ">
                                <b>Other<span style={{ color: "red" }}>*</span></b>
                                <InputText
                                    value={showAddDialog.other}
                                    onChange={(e) => {
                                        setShowAddDialog({ ...showAddDialog, other: e.target.value });
                                    }}
                                    className="w-full" />
                            </div>}

                            <div className="col-12 f-bold">
                                <b>Consent Form</b>
                                <span style={{ color: "red" }}>*</span>
                            </div>
                            <div className="col-12 f-bold">
                                <b>
                                    <div className="mr-2">
                                        <Button
                                            label={<>Upload Consent Form</>}
                                            loading={loading}
                                            onClick={() => {
                                                inputConsentFileRef.current.value = null; // Clear the input value
                                                inputConsentFileRef.current.click();
                                            }}
                                            className="p-button-success mr-3"
                                        />
                                        <input
                                            ref={inputConsentFileRef}
                                            type={"file"}
                                            onChange={(e) => handleConsentFormUpload(e)}
                                            style={{ display: "none" }}
                                            accept="application/pdf"
                                        ></input>
                                    </div>
                                </b>
                            </div>
                            {showAddDialog.consentForm.length > 0 && <PrintOut isReport={false} base64={pdf} setBase64={setPdf} showDialog={showPdf} setShowDialog={setShowPdf} />}
                            {showAddDialog.consentForm.length > 0 && (
                                <>
                                    <span width="200px" style={{ width: "200px", objectFit: "cover", marginLeft: "5px", marginBottom: "10px", cursor: "pointer", }}
                                        onClick={() => {
                                            setPdf(`${showAddDialog?.consentForm}`);
                                            setShowPdf(true);
                                        }}
                                    >
                                        <i className={PrimeIcons.FILE_PDF} style={{ fontSize: "16px", color: "red" }}></i> {showAddDialog.consentFormName}
                                    </span>
                                </>
                            )}

                            <div className="col-12 f-bold">
                                <b>Signature</b>
                                <span style={{ color: "red" }}>*</span>
                            </div>
                            <div className="col-12 f-bold">
                                <b>
                                    <div className="mr-2">
                                        <Button
                                            label={<>Upload Signature</>}
                                            loading={loading}
                                            onClick={() => {
                                                inputFileRef.current.value = null; // Clear the input value
                                                inputFileRef.current.click();
                                            }}
                                            className="p-button-success mr-3"
                                        />
                                        <input
                                            ref={inputFileRef}
                                            type={"file"}
                                            multiple
                                            onChange={(e) => handleFileUpload(e)}
                                            style={{ display: "none" }}
                                            accept=".png,jpg,jpeg"
                                        ></input>
                                    </div>
                                </b>
                            </div>
                        </div>
                    </>
                )}


                {showAddDialog.signature.length > 0 && (
                    <>
                        <Image
                            preview={true}
                            src={showAddDialog.signature}
                            template="Logo"
                            alt="Logo"
                            width="50px"
                            style={{ width: "50px", objectFit: "cover" }}
                        />
                        ,
                    </>
                )}
            </Dialog>
            <DataTable
                size="small"
                scrollable={true}
                scrollHeight="400px"
                value={excecutiveMembers}
                dataKey="id"
                loading={loading}
                rowsPerPageOptions={[5, 10, 25]}
                className="datatable-responsive"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
                emptyMessage="No members found."
                responsiveLayout="scroll"
                // selection={selectedMember}
                // onSelectionChange={(e) => setSelectedMember(e.value)}
                resizableColumns
                columnResizeMode="expand"
                // filters={filters}
                filterDisplay="Name"
                globalFilterFields={["Name"]}
            >
                <Column field="firstname" header="Name" sortable></Column>
                <Column field="surname" header="Surname" sortable></Column>

                {isIecEdit && <Column body={(e) => maskMiddle(e.idNumber)} field="idNumber" header="ID Number" sortable></Column>}

                <Column field="registrationNumber" header="Registration Number" sortable></Column>

                <Column field="role" header="Role" sortable body={e => e.partyExecutiveRoleID === 9 ? `${e.role} (${e.other})` : e.role}></Column>
                <Column field="emailAddress" header="Email" sortable></Column>
                {!hideButtons && <Column

                    field="actions"
                    header="Actions"
                    body={(e) => (
                        <>
                            <Button
                                icon={"pi pi-pencil"}
                                style={{ textAlign: "center", width: "30px", height: "30px" }}

                                onClick={() => {
                                    setShowUpdate({ ...showUpdate, ...e, show: true })
                                }}
                                className=" p-button-rounded mr-2" />
                            <Button
                                disabled={isOnlyView}
                                onClick={(ee) => {

                                    confirmDeleteExecutiveMember(ee, e)



                                }}
                                style={{ textAlign: "center", width: "30px", height: "30px" }}
                                icon={"pi pi-trash"}
                                className="p-button-danger p-button-rounded mr-2"
                                tooltip="Click to delete"
                            />
                        </>
                    )}
                ></Column>}

            </DataTable>
        </>
    );
}
